export class SqlError extends Error {}
export class InvalidInputError extends SqlError {}
